

import { Injectable } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { PaymentProcess } from '../_models/paymentProcess.interface';

import { PSPDepositBank } from '../_models/depositbank.interface';

import { PaymentReportExport } from '../_models/paymentReportExport.interface';

import { PaymentProperties } from '../_models/paymentProperties.interface';

import { AppConfig } from '../_helpers/appconfig.service';

@Injectable()
export class PaymentProcessService {

    public defaultHeaders = new HttpHeaders();

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

    httpOptions: any;

    constructor(
        protected httpClient: HttpClient
    ) {}

    /**
     * create_payment Process
     * Create a Payment Process
     */
    public createPayment(body: PaymentProcess, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createPayment.');
        }


        return this.httpClient.post<PaymentProcess>(`${this._kcmssvcURL}/payment_process`,
            body,
            {

            }
        );
    }//end


    /**
     Deposit Post
     */


    public createDeposit(publicId: string, body: PSPDepositBank, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createDeposit.');
        }


        return this.httpClient.post<PSPDepositBank>(`${this._kcmssvcURL}/psp_operations/${encodeURIComponent(String(publicId))}/categorize`,
            body,
            {

            }
        );
    }//end




    /**
     * getPaymentProcess
     * get individual Payment Process details
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     */
    public getPaymentProcess(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling get Payment Process detail.');
        }
        return this.httpClient.get<PaymentProcess>(`${this._kcmssvcURL}/payment_process/${encodeURIComponent(String(publicId))}`, {});
    }

    /**
  * get_payment_process
  * Get a Payment Process
  * @param publicId
  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  * @param reportProgress flag to report request and response progress.
  */
    public getPaymentProcessList(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling get Payment Process List.');
        }

        return this.httpClient.get<Array<PaymentProcess>>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/payment_processes`,
            {

            }
        );
    }//end method




    /**
       * Cancel a Payment Process
       * Cancel a Payment Process
       * @param publicId
       * @param body
       * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
       * @param reportProgress flag to report request and response progress.
       */
    public cancelPaymentProcess(publicId: string, body?: PaymentProcess, observe?: 'body', reportProgress?: boolean): Observable<PaymentProcess>;
    public cancelPaymentProcess(publicId: string, body?: PaymentProcess, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentProcess>>;
    public cancelPaymentProcess(publicId: string, body?: PaymentProcess, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentProcess>>;
    public cancelPaymentProcess(publicId: string, body?: PaymentProcess, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling cancelPaymentProcess.');

        }

        return this.httpClient.post<PaymentProcess>(`${this._kcmssvcURL}/payment_process/${encodeURIComponent(String(publicId))}/cancel`,

            {

            }

        );


    }

    /**
     * confirm_payment_process
     * Confirm a Payment Process
     * @param publicId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public confirmPaymentProcess(publicId: string, body?: PaymentProcess, observe?: 'body', reportProgress?: boolean): Observable<PaymentProcess>;
    public confirmPaymentProcess(publicId: string, body?: PaymentProcess, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentProcess>>;
    public confirmPaymentProcess(publicId: string, body?: PaymentProcess, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentProcess>>;
    public confirmPaymentProcess(publicId: string, body?: PaymentProcess, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling confirmPaymentProcess.');
        }

        return this.httpClient.post<PaymentProcess>(`${this._kcmssvcURL}/payment_process/${encodeURIComponent(String(publicId))}/confirm`,
            body,
            {

            }
        );
    }//end

    /**
   * getPaymentProcessReportLisPSp

   */
    public getPaymentProcessReportListPSP(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        return this.httpClient.get<Array<any>>
        (`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/payment.include_psp_tin`,
            {
            withCredentials: null,

                observe: observe,
                reportProgress: reportProgress
            }
        );
    }// end method



    /**
   * getPaymentProcessReportListNew
   * Get a Payment Process
   * @param publicId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPaymentProcessReportListNew(publicId: string, from_date?: string, to_date?: string, limit?: number, start?: number, search?: string, type?:string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (publicId === null || publicId === undefined) {
        throw new Error('Required parameter customer public Id was null or undefined when calling to get payments List.');
    }


    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

    if (from_date !== undefined && from_date !== null && from_date.toString() !== '') {
        queryParameters = queryParameters.set('from_date', <any>from_date);
    }

    if (to_date !== undefined && to_date !== null && to_date.toString() !== '') {
        queryParameters = queryParameters.set('to_date', <any>to_date);
    }

    if (limit !== undefined && limit !== null && limit !== 0 && limit.toString() !== '') {
        queryParameters = queryParameters.set('limit', <any>limit);
    }
    if (start !== undefined && start !== null && start.toString() !== '') {
        queryParameters = queryParameters.set('start', <any>start);
    }

    if (type !== undefined && type !== null && type !== '') {
        queryParameters = queryParameters.set('type', <any>type);
    }

    if (search !== undefined && search !== null && search !== '') {
        queryParameters = queryParameters.set('search', <any>search);
    }

    return this.httpClient.get<Array<PaymentProcess>>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/payments`,
        {
            params: queryParameters
            , withCredentials: null,

            observe: observe,
            reportProgress: reportProgress
        }
    );
}//end method




    /**
        * getPaymentPSPProcess
        * get individual Payment Process details
        * @param publicId
        * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
        */
    public getPaymentProcessPsp(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling get Payment Process detail.');
        }
        return this.httpClient.get<PaymentProcess>(`${this._kcmssvcURL}/psp_operations/${encodeURIComponent(String(publicId))}`,
            {

            }
        );
    }//end method

    public getConfigurationDetails(publicId: string):Observable<PaymentProperties>{
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter customer publicId was null or undefined when calling to get configuration details.');
        }
        return this.httpClient.get<PaymentProperties>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/payment.properties`);
    }

    public reportExport(publicId: string, from_date: string, to_date: string, type:string, search: string, template: string ): Observable<PaymentReportExport> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (from_date !== undefined && from_date !== null && from_date.toString() !== '') {
            queryParameters = queryParameters.set('from_date', <string>from_date);
        }

        if (to_date !== undefined && to_date !== null && to_date.toString() !== '') {
            queryParameters = queryParameters.set('to_date', <string>to_date);
        }

        if (type !== undefined && type !== null && type !== '') {
            queryParameters = queryParameters.set('type', <string>type);
        }

        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <string>search);
        }

        if (template !== undefined && template !== null && template !== '') {
            queryParameters = queryParameters.set('template', <string>template);
        }

        return this.httpClient.get<PaymentReportExport>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/payments/export`,
        {
            params: queryParameters
        });
    }

}//end class
